import {EnumValue, ListRequestBody, MultiselectItem, PossibleActions, State} from "./admin.interface";
import {BaseDto, InObj, RequestConfig, Result, updateBomRequest} from "./common.interface";
import {Bom, IBomDetail, IBomElement, IBomEntry, IBomParent} from "./bom.interface";
import {Type} from "./project-type.interface";
import {Project, ProjectInfo} from "./project.interface";
import {SpecificationsBuyer} from "./specifications.interface";
import {NominativeInfo} from "./name-list.interface";

export class QuoteRequestBody extends ListRequestBody {

    override reset() {
        const filter = this.filters.QUOTE
        Object.keys(filter).forEach(field => filter[field] = null)
        filter.state = State.ALL
    }
}

export enum QuoteState {
    CREATED,
    DELIVERED,
    ACCEPTED,
    ORDERED,
    REJECTED,
    LOST,
    SUPERSEDED
}

export enum QuoteActions {
    EDIT = "edit",
    DELIVER = "deliver",
    ACCEPT = "accept",
    REJECT = "reject",
    ORDER = "order",
    MARK_LOST = "markLost",
    MARK_SUPERSEDED = "markSuperseded",
}

export interface QuoteResult extends Result {
    id: number
    company: string
    code: string
    description: string
    date: Date
    customer: string
    vatId: string
    taxableTotal: number
    state: EnumValue

}

export class QuoteData extends BaseDto<QuoteInfo, QuoteData> {
    date: Date;
    description?: string
    headquarter: any;
    nominative: any;
    project: ProjectInfo;
    specificationsProject?: boolean;
    company?: MultiselectItem | number;

}

export class QuoteInfo extends QuoteData implements IBomParent {
    id?: number;
    code?: string;
    companyName?: string;
    payment?: any;
    vat?: any;
    account?: any;
    specificationsBuyer?: any;
    state: EnumValue
    possibleActions?: PossibleActions;
    entries: QuoteEntry[] = []

    totalCost: number
    taxableTotal: number
    total: number

    toBomRequest(bom: Bom): QuoteData {
        const req = super.asRequest();
        req['account'] = this.nominative.id
        delete req.nominative
        delete req.company
        delete req['code']
        delete req['disabled']
        delete req['fiscalYear']
        delete req['currency']
        delete req['state']
        if(bom)
            updateBomRequest(req as unknown as IBomParent, bom)
        return req
    }

    override toRequest(obj: QuoteInfo, config?: RequestConfig): QuoteData {
        const req = super.toRequest(obj, {deleteExcludes: ['headquarter']});
        req['account'] = this.nominative.id
        delete req.nominative
        delete req.company
        delete req['code']
        delete req['disabled']
        delete req['fiscalYear']
        delete req['currency']
        delete req['state']

        return req;
    }

    override forUi() {
        this.date = new Date(this.date)
        return super.forUi();
    }

    get entryList(): IBomEntry[] {
        return this.entries
    }

}

export class QuoteElement implements IBomElement {
    id: number
    code?: string
    state?: number
    index?: number
    description: string
    longDescription?: string | null
    quantity?: number
    listPrice?: number | null
    discount?: number
    cost?: number
    totalCost?: number

    product?: InObj
    supplier?: InObj
    um?: InObj

}

export class QuoteEntry extends QuoteElement implements IBomEntry {
    configured?: boolean
    markupPrct?: number
    sellDiscount?: boolean
    price?: number
    totalPrice?: number
    entries?: QuoteEntryDetail[] = []

    get entryList(): IBomDetail[] {
        return this.entries
    }
}

export class QuoteEntryDetail extends QuoteElement implements IBomDetail {
    coefficient?: number = 1.00

}

export interface QuoteOrderReq {
    project?: number;
    buyerAccountId?: number;
    buyerAccount?: NominativeInfo;
}

export interface QuoteOrderResult {
    done: boolean;
    needsAccount: boolean;
    message?: string;
    buyer?: SpecificationsBuyer;
}